module.exports = __webpack_public_path__ + "static/media/success.48a078ae.svg";